module.exports = __webpack_public_path__ + "0e1bf5e067d468e945c50a417f821d51.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-fancy-dress.png
// module id = 1901
// module chunks = 0